import { Track } from './Track';
export class IncomingTrack {
    track;
    userSessionId;
    constructor(trackId, userSessionId, outputFunction) {
        this.track = new Track(trackId, false);
        this.userSessionId = userSessionId;
        this.track.setListener(outputFunction);
    }
    feedFrame(frame, done) {
        this.track.emit(frame, done);
    }
    getUserSessionId() {
        return this.userSessionId;
    }
}
